<template>
  <modal
    :ignoreBackdropClick="true"
    :show.sync="shown"
    class="modal-options rating-order"
    v-if="order != null"
    modalClasses="modal-dialog-centered modal-dialog-scrollable"
  >
    <div slot="header">
      <h4 class="title title-up" :style="{'color':myTheme.modalTextColor}" >{{ order.location.name }}</h4>
      <p class="header-address">
        <i class="k-icon-location-pointer"></i>
        {{ generateFromatedAddress(order.location.address) }}
      </p>
    </div>
    <alert type="danger" v-if="showAlert">
      <div class="alert-icon">
        <i class="now-ui-icons k-icon-notifications"></i>
      </div>
      <strong>{{$t('message.resource_error_notify_title')}}</strong> {{ msgAlert }}
    </alert>

      <template>
      <p class="big-title" :style="{'color':myTheme.modalTextColor}">{{ $t('message.review_location_title', {location_name : order.location.name}) }}</p>
      <div class="food">
        <p  class="medium-title"><i class="k-icon-menu2"></i> {{$t('message.review_food_question_title')}}</p>
        <el-rate
          v-model="rating.food"
          :icon-classes="iconClassesLocation"
          void-icon-class="k-icon-rating"
          :texts="reviews_options"
          :show-text="true"
          :max="max"
          :colors="ratingIconColors"
        >
        </el-rate>
      </div>
      <el-divider></el-divider>
      <div class="service">
        <p  class="medium-title"><i class="k-icon-food-1"></i> {{$t('message.review_service_question_title')}}</p>
        <el-rate
          v-model="rating.service"
          :icon-classes="iconClassesLocation"
          void-icon-class="k-icon-rating"
          :texts="reviews_options"
          :show-text="true"
          :max="max"
          :colors="ratingIconColors"
        ></el-rate>
      </div>
      <el-divider></el-divider>
      <div class="deliver_collection">
        <p v-if="order.order_type == ORDER_TYPE.Delivery.id" class="medium-title"><i class="k-icon-delivery-outline"></i> {{$t('message.review_delivery_service')}}</p>
        <p v-else-if="order.order_type == ORDER_TYPE.Collection.id" class="medium-title"><i class="k-icon-pick-up"></i> {{$t('message.review_pickup_service')}}</p>
        <p v-else class="medium-title"><i class="k-icon-table-outline"></i> {{$t('message.review_table_service')}}</p>
        <el-rate
          v-model="rating.delivery_collection"
          :icon-classes="iconClassesLocation"
          void-icon-class="k-icon-rating"
          :texts="reviews_options"
          :show-text="true"
          :max="max"
          :colors="ratingIconColors"
        ></el-rate>
      </div>
    </template>
    <el-divider></el-divider>
      <div class="option">
        <p>{{$t("message.additional_comment")}}</p>
        <fg-textarea
          class="no-border"
          :placeholder="$t('input.placeholder.additional_comments')"
          addon-left-icon="now-ui-icons k-icon-comment"
          v-model="rating.comment"
          :maxlength=700
        ></fg-textarea>
        <p class="textarea-info"> {{$t('text.remaining_characters', {count:700 - rating.comment.length} )}}</p>
        <p class="textarea-info error" v-if="rating.comment!= '' && rating.comment.length < 25">{{$t('validation.provide_comment_min_characters')}}</p>
      </div>
   
    <el-divider></el-divider>
    <template>
      <p class="big-title" :style="{'color':myTheme.modalTextColor}">{{$t("message.review_food")}}</p>
      <div  v-for="(food,foodIndex) in order.orderItems" :key="foodIndex">
      <cards class="previews-order-card" v-if="food.menuItem"  >
          <div class="food-rating-top">
            <div class="item-name">{{food.menuItem.name}}</div>  
            <div class="item-desc">{{food.menuItem.description}}</div>
            <div class="item-price">{{ getMenuItemPrice(food.menuItem, order.order_type) | currency(currentCurrency)}}</div>
            <div class="item-dietaries">{{$t("text.dietaries")}}</div>

          </div>
          <div class="food-rating-bottom">
          <p class="small-title" :style="{'color':myTheme.modalTextColor}">{{$t("text.your_rating")}}</p>  
          <el-rate
          v-model="food.rating" 
          :icon-classes="iconClassesStars"
          void-icon-class=" k-icon-forkstar"
          :texts="['1', '2', '3', '4', '5' , '6', '7']"
          :show-text="true"
          :max="max"
          :colors="ratingIconColors"
        ></el-rate>

          </div>
      </cards>
      </div>
    </template>

       <template slot="footer">
      <n-button type="success" @click.native="saveOrderReview()">
        {{$t("button.save_review")}}
      </n-button>
      <n-button type="default" @click.native="closeModal()">{{$t("button.cancel")}}</n-button>
    </template>
  </modal>
</template>
<script>
import {
  Button,
  Cards,
  Modal,
  FormTexterea,
  Alert
} from "@/components";
import {  ORDER_TYPE } from "@/utilities/enums";
import { generateMenuItemRating, getMenuItemPrice, generateFromatedAddress } from "@/utilities/helper";
import staticColors from "@/model/colors";

export default {
  name: "add-review-modal",
  components: {
    [Button.name]: Button,
    Cards,
    Modal,
    Alert,
    [FormTexterea.name]: FormTexterea
  },
  props: {
    order: Object,
  },
  data() {
    return {
      ORDER_TYPE,
      getMenuItemPrice,
      generateFromatedAddress,
      copyOrder : null,
      shown: false,
      showAlert: false,
      msgAlert: "",
      iconClassesLocation: ["k-icon-rating","k-icon-rating","k-icon-rating","k-icon-rating","k-icon-rating","k-icon-rating","k-icon-rating"],
      iconClassesStars: ["k-icon-forkstar","k-icon-forkstar","k-icon-forkstar","k-icon-forkstar","k-icon-forkstar","k-icon-forkstar","k-icon-forkstar"],
      max:7,
      rating:{
        comment:"",
        food:0,
        service:0,
        delivery_collection : 0
      },
      reviews_options : [this.$t("reviews.forking_awful"),this.$t("reviews.forking_awful"),this.$t("reviews.forking_awful"),this.$t("reviews.forking_okay"),this.$t("reviews.forking_okay"),this.$t("reviews.forking_okay"),this.$t("reviews.forking_awesome")],
      ratingIconColors:['#99A9BF', staticColors.ratingOkey, staticColors.ratingGood],
    };
  },
  methods: {
    saveOrderReview() {

      if(!this.checkRequiredRating()) {
        this.msgAlert = this.$t("validation.review_verification_message")
        this.showAlert = true;
        return
      }
      if(this.rating.comment != "" && this.rating.comment.length < 25){
        return
      }
      //--- get the rating data
      let objRating = {
        order_id : this.order.id,
        food_rating : this.rating.food,
        service_rating : this.rating.service,
        collection_delivery_rating : this.rating.delivery_collection,
        content: this.rating.comment,
        order_items : generateMenuItemRating(this.order.orderItems)
      }

      this.$root.$emit("PUSH_REVIEW",{order:this.order, rating:objRating ,save:true})
    },
    checkRequiredRating() {
      return this.rating.food && this.rating.service && this.rating.delivery_collection;
    },

    openModal() {
      this.shown = true;
    },
    closeModal() {
      this.shown = false;
      this.rating = {
        comment:"",
        food:0,
        service:0,
        delivery_collection : 0
      };
    }
  }
};
</script>
<style scoped>
.form-group.input-group{
  padding: 0px;
}
</style>
